


































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';
import Requester from '../../requester';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';
import CustomDialog from '../CustomDialog.vue';
import MedicaoGlicemiaDatatable from '../medicoes/MedicaoGlicemiaDatatable.vue';
import MedicaoGlicemiaDados from '../medicoes/MedicaoGlicemiaDados.vue';
import MedicaoPressaoArterialDados from '../medicoes/MedicaoPressaoArterialDados.vue';
import MedicaoPressaoArterialDatatable from '../medicoes/MedicaoPressaoArterialDatatable.vue';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { MedicaoGlicemia } from '../../../../back/src/entity/MedicaoGlicemia';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';

export default Vue.extend({
  name: 'ThePacientesDadosMedicoes',
  components: {
    Carregando,
    Confirmar,
    CustomDialog,
    MedicaoGlicemiaDatatable,
    MedicaoGlicemiaDados,
    MedicaoPressaoArterialDados,
    MedicaoPressaoArterialDatatable,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      loading: {
        convite: true,
        dados: false,
        usuario: true,
      },
      dialog: {
        open: false,
        medicaoGlicemiaSelecionada: null,
        medicaoPressaoSelecionada: null,
      },
      showDadosAcompanhamento: true,
      convitePaciente: null,
      usuario: null,
      medicoesGlicemia: [],
      gestacoes: [],
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    loadingAll(): boolean {
      return this.loading.convite && this.loading.dados;
    },
    pacienteUsuarioId() {
      return this.paciente.usuario_id;
    },
    btnConviteText() {
      if (this.usuario) return 'Paciente cadastrada';
      if (this.paciente.cancelled) return 'Paciente inativa';
      if (this.convitePaciente && this.pacienteUsuarioId) return 'Inativar acompanhamento';
      if (this.convitePaciente) return 'Reenviar convite';
      return 'Habilitar acompanhamento';
    },
    btnDisabled() {
      return (this.convitePaciente && this.pacienteUsuarioId)
        || this.paciente.cancelled
        || !!this.usuario;
    },
    conviteHint() {
      if (this.usuario && !this.usuario.ativo) return 'Ativação pendente';
      if (this.convitePaciente && !this.usuario) {
        return `Enviado em ${moment(this.convitePaciente.updated).format('DD/MM/YYYY')}`;
      }
      return null;
    },
    gestacoesFiltradasOrdenadas() {
      return _.orderBy(
        this.gestacoes,
        ['parto.data_parto'],
        ['desc'],
      );
    },
  },
  async mounted() {
    await this.buscaConvitePaciente();
    await this.buscaUsuario();
    if (this.usuario) {
      await this.buscaGestacoes();
    }
  },
  methods: {
    async habilitarAcompanhamento() {
      let txt: string = '';
      if (!this.convitePaciente) {
        txt = `Tem certeza que deseja habilitar o acompanhamento para ${this.paciente.nome}? Um convite será enviado por e-mail para ${this.paciente.email}`;
      } else if (this.convitePaciente && this.pacienteUsuarioId) {
        txt = `Tem certeza que deseja inativar o acompanhamento de ${this.paciente.nome}? Esta ação irá inativar o acesso da paciente ao sistema.`;
      } else if (this.convitePaciente) {
        txt = `Deseja reenviar o convite para ${this.paciente.email}?`;
      }
      if (await this.confirmar.open(
        this.btnConviteText,
        txt,
      ) === false) {
        return;
      }
      if (!this.convitePaciente) {
        this.convidaPaciente();
        return;
      }
      if (this.convitePaciente && !this.pacienteUsuarioId) {
        this.reenviaConvite();
        return;
      }
      this.$root.$emit('avisoSnackbar', { color: 'warning', text: 'Implementar essa funcao' });
    },
    async buscaConvitePaciente() {
      this.loading.convite = true;
      try {
        const response = await Requester.convitePaciente.buscaConvitePaciente({
          paciente_id: this.paciente.id,
        });
        if (response.errors.length === 0) {
          this.convitePaciente = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.convite = false;
      }
    },
    async buscaUsuario(): Promise<void> {
      this.loading.usuario = true;
      try {
        const response = await Requester.usuario.usuarios({ paciente_id: this.paciente.id });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else if (response.data.length > 0) {
          this.usuario = response.data.pop();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuario = false;
      }
    },
    async convidaPaciente() {
      this.loading.convite = true;
      try {
        const response = await Requester.convitePaciente.criaConvitePaciente({
          paciente_id: this.paciente.id,
          email: this.paciente.email,
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.convitePaciente = response.data;
          this.$root.$emit('avisoSnackbar', { color: 'success', text: ['Convite enviado'] });
        }
      } catch (error) {
        this.$root.$emit('requestError', error);
      } finally {
        this.loading.convite = false;
      }
    },
    async reenviaConvite() {
      this.loading.convite = true;
      try {
        const response = await Requester.convitePaciente
          .reenviaConvitePaciente(this.convitePaciente.id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.convitePaciente = response.data;
          this.$root.$emit('avisoSnackbar', { color: 'success', text: ['Convite reenviado'] });
        }
      } catch (error) {
        this.$root.$emit('requestError', error);
      } finally {
        this.loading.convite = false;
      }
    },
    async buscaGestacoes() {
      this.loading = true;
      try {
        const response = await Requester.paciente.gestacoes(
          this.usuario.paciente_id,
          {
            relations: ['parto'],
            loadEagerRelations: false,
          },
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.gestacoes = response.data;
          const promiseArray = [];
          this.gestacoes.forEach((element, index) => {
            promiseArray.push(this.buscaMedicoesGlicemia(index) as never);
            promiseArray.push(this.buscaMedicoesPressao(index) as never);
          });
          await Promise.all(promiseArray);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async buscaMedicoesGlicemia(gestacaoIndex: number) {
      this.loading = true;
      try {
        const response = await Requester.gestacao.medicoesGlicemia(
          this.gestacoes[gestacaoIndex].id,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$set(this.gestacoes[gestacaoIndex], 'medicoes_glicemia', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async buscaMedicoesPressao(gestacaoIndex: number) {
      this.loading = true;
      try {
        const response = await Requester.gestacao.medicoesPressaoArterial(
          this.gestacoes[gestacaoIndex].id,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$set(this.gestacoes[gestacaoIndex], 'medicoes_pressao_arterial', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    resetDialog() {
      this.dialog.open = false;
      this.dialog.medicaoGlicemiaSelecionada = null;
      this.dialog.medicaoPressaoSelecionada = null;
    },
    verMedicaoGlicemia(medicao: MedicaoGlicemia) {
      this.resetDialog();
      this.dialog.medicaoGlicemiaSelecionada = medicao;
      this.dialog.open = true;
    },
    verMedicaoPressaoArterial(medicao: MedicaoPressaoArterial) {
      this.resetDialog();
      this.dialog.medicaoPressaoSelecionada = medicao;
      this.dialog.open = true;
    },
  },
});
